// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "f439a2fe75f953db7f96" + "/js/" + chunkId + ".js";
};